/**
 * KG button hover — Williams Knife style circular wipe.
 * Usage: add class "kg-btn-hover" to any <a> or <button>.
 * Optional CSS vars: --kg-btn-hover-fill, --kg-btn-hover-color
 */
(function () {
  var SELECTOR = '.kg-btn-hover';
  var EASING = 'cubic-bezier(0.3, 1, 0.3, 1)';
  var DURATION = 600;
  var instances = new WeakMap();

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  function ensureStructure(el) {
    var fill = el.querySelector('[data-kg-btn-fill]');
    if (!fill) {
      fill = document.createElement('span');
      fill.className = 'kg-btn-hover__fill';
      fill.setAttribute('data-kg-btn-fill', '');
      fill.setAttribute('aria-hidden', 'true');
      el.insertBefore(fill, el.firstChild);
    }

    var text = el.querySelector('[data-kg-btn-text]');
    if (!text) {
      text = document.createElement('span');
      text.className = 'kg-btn-hover__text';
      text.setAttribute('data-kg-btn-text', '');
      Array.prototype.slice.call(el.childNodes).forEach(function (node) {
        if (node !== fill) text.appendChild(node);
      });
      el.appendChild(text);
    }

    return { fill: fill, text: text };
  }

  function KgBtnHover(el) {
    this.el = el;
    this.fillAnim = null;
    var parts = ensureStructure(el);
    this.fill = parts.fill;
    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);

    if (isTouch()) return;

    el.addEventListener('mouseenter', this.onEnter);
    el.addEventListener('mouseleave', this.onLeave);
  }

  KgBtnHover.prototype.cancelFill = function () {
    if (!this.fillAnim) return;
    try {
      this.fillAnim.commitStyles();
    } catch (e) {}
    this.fillAnim.cancel();
    this.fillAnim = null;
  };

  KgBtnHover.prototype.onEnter = function () {
    this.el.classList.add('is-kg-btn-hovered');
    this.cancelFill();
    this.fillAnim = this.fill.animate(
      [
        { transform: 'translate3d(0, 76%, 0)' },
        { transform: 'translate3d(0, 0%, 0)' }
      ],
      { duration: DURATION, easing: EASING, fill: 'forwards' }
    );
  };

  KgBtnHover.prototype.onLeave = function () {
    this.el.classList.remove('is-kg-btn-hovered');
    this.cancelFill();
    this.fillAnim = this.fill.animate(
      [{ transform: 'translate3d(0, -76%, 0)' }],
      { duration: DURATION, easing: EASING, fill: 'forwards' }
    );
  };

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll
      ? scope.querySelectorAll(SELECTOR)
      : [];

    if (scope !== document && scope.matches && scope.matches(SELECTOR)) {
      buttons = [scope].concat(Array.prototype.slice.call(buttons));
    }

    Array.prototype.forEach.call(buttons, function (el) {
      if (instances.has(el)) return;
      instances.set(el, new KgBtnHover(el));
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();



/**
 * Set header height as CSS var for submenu dropdown padding-top.
 * Updates on resize, scroll shrink (scrolled-past-header / logo size), and ResizeObserver.
 */
(function () {
  var headerEl = null;
  var rafId = null;
  var resizeObserver = null;
  var mutationObserver = null;
  var transitionTimer = null;

  function getHeader() {
    return (
      document.querySelector(".kg-header-wrapper") ||
      document.querySelector("header.kg-header") ||
      document.querySelector("sticky-header") ||
      document.querySelector(".header-wrapper")
    );
  }

  function setKgHeaderHeight() {
    var header = headerEl || getHeader();
    if (!header) return;
    headerEl = header;

    var height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty(
      "--kg-header-height",
      height + "px",
    );
  }

  function scheduleSet() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = null;
      setKgHeaderHeight();
    });
  }

  /** Re-measure after CSS transition when header shrinks on scroll. */
  function scheduleSetAfterTransition() {
    scheduleSet();
    if (transitionTimer) clearTimeout(transitionTimer);
    transitionTimer = setTimeout(setKgHeaderHeight, 450);
  }

  function bindObservers() {
    headerEl = getHeader();
    if (!headerEl) return;

    setKgHeaderHeight();

    if (typeof ResizeObserver !== "undefined") {
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(scheduleSet);
      resizeObserver.observe(headerEl);
      var inner =
        headerEl.querySelector("header.kg-header") ||
        headerEl.querySelector("header");
      if (inner && inner !== headerEl) resizeObserver.observe(inner);
    }

    var sectionHeader = document.querySelector(".section-header");
    if (sectionHeader && typeof MutationObserver !== "undefined") {
      if (mutationObserver) mutationObserver.disconnect();
      mutationObserver = new MutationObserver(scheduleSetAfterTransition);
      mutationObserver.observe(sectionHeader, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    bindObservers();
    window.addEventListener("scroll", scheduleSet, { passive: true });
    window.addEventListener("resize", scheduleSet);
  });

  document.addEventListener("shopify:section:load", function () {
    headerEl = null;
    bindObservers();
  });
})();


/**
 * Header dropdown: open all menu levels on hover (desktop).
 * Top menu → submenu, submenu → child menu. Click disabled when hover works.
 */
(function () {
  var SELECTOR = ".kg-header nav.header__inline-menu details";
  var CLOSE_DELAY = 120;
  var initialized = new WeakSet();

  function canHover() {
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  function setExpanded(details, open) {
    var summary = details.querySelector(":scope > summary");
    if (summary) summary.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function openMenu(details) {
    details.setAttribute("open", "");
    setExpanded(details, true);
  }

  function closeNested(details) {
    var nested = details.querySelectorAll("details[open]");
    Array.prototype.forEach.call(nested, function (item) {
      item.removeAttribute("open");
      setExpanded(item, false);
    });
  }

  function closeMenu(details) {
    closeNested(details);
    details.removeAttribute("open");
    setExpanded(details, false);
  }

  function bind(details) {
    if (initialized.has(details)) return;
    initialized.add(details);

    var closeTimer = null;
    var hoverTarget = details.closest("li") || details;

    function clearClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function scheduleClose() {
      clearClose();
      closeTimer = setTimeout(function () {
        closeMenu(details);
      }, CLOSE_DELAY);
    }

    hoverTarget.addEventListener("mouseenter", function () {
      if (!canHover()) return;
      clearClose();
      openMenu(details);
    });

    hoverTarget.addEventListener("mouseleave", function () {
      if (!canHover()) return;
      scheduleClose();
    });

    details.addEventListener("focusin", function () {
      clearClose();
      openMenu(details);
    });

    details.addEventListener("focusout", function () {
      setTimeout(function () {
        if (!details.contains(document.activeElement)) closeMenu(details);
      }, 0);
    });

    var summary = details.querySelector(":scope > summary");
    if (summary) {
      summary.addEventListener("click", function (event) {
        if (!canHover()) return;
        // Hover-only: block native details toggle on click
        event.preventDefault();
      });
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var menus = scope.querySelectorAll
      ? scope.querySelectorAll(SELECTOR)
      : [];
    Array.prototype.forEach.call(menus, bind);
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();



/**
 * Vertical product thumbnail slider:
 * Dawn only scrolls horizontally; this column layout needs vertical scroll.
 */
(function () {
  var MQ = "(min-width: 750px)";

  function getViewer(gallery) {
    return gallery.querySelector('[id^="GalleryViewer"]');
  }

  function getThumbnails(gallery) {
    return gallery.querySelector('[id^="GalleryThumbnails"]');
  }

  function getList(thumbs) {
    return thumbs.querySelector('[id^="Slider-Thumbnails"]');
  }

  function getStep(list) {
    var items = list.querySelectorAll('[id^="Slide-Thumbnails"]');
    if (items.length < 2) {
      return (items[0] && items[0].offsetHeight) || 80;
    }
    var gap = 0;
    try {
      gap = parseFloat(window.getComputedStyle(list).gap) || 0;
    } catch (e) {}
    var delta = items[1].offsetTop - items[0].offsetTop;
    return delta > 0 ? delta : items[0].offsetHeight + gap;
  }

  function updateButtons(thumbs, list) {
    var prev = thumbs.querySelector('button[name="previous"]');
    var next = thumbs.querySelector('button[name="next"]');
    if (!prev || !next) return;

    var maxScroll = list.scrollHeight - list.clientHeight;
    var atStart = list.scrollTop <= 1;
    var atEnd = maxScroll <= 1 || list.scrollTop >= maxScroll - 1;

    // Do not use native [disabled] — Dawn may set it wrongly and block clicks entirely
    prev.removeAttribute("disabled");
    next.removeAttribute("disabled");

    prev.setAttribute("aria-disabled", atStart || maxScroll <= 1 ? "true" : "false");
    next.setAttribute("aria-disabled", atEnd ? "true" : "false");
    prev.classList.toggle("is-disabled", atStart || maxScroll <= 1);
    next.classList.toggle("is-disabled", atEnd);
  }

  function syncHeight(gallery) {
    var viewer = getViewer(gallery);
    var thumbs = getThumbnails(gallery);
    if (!viewer || !thumbs) return;

    if (!window.matchMedia(MQ).matches) {
      gallery.style.removeProperty("--gallery-viewer-height");
      return;
    }

    var height = Math.round(viewer.getBoundingClientRect().height);
    if (height > 0) {
      gallery.style.setProperty("--gallery-viewer-height", height + "px");
    }

    var list = getList(thumbs);
    if (list) updateButtons(thumbs, list);

    if (typeof thumbs.initPages === "function") {
      thumbs.initPages();
    }

    // Dawn SliderComponent may re-apply [disabled] after initPages — clear it again
    if (list) {
      requestAnimationFrame(function () {
        updateButtons(thumbs, list);
      });
    }
  }

  function onThumbButtonClick(event) {
    var button = event.currentTarget;
    var thumbs = button.closest('[id^="GalleryThumbnails"]');
    if (!thumbs) return;

    var list = getList(thumbs);
    if (!list) return;

    // Only take over when the list is a vertical column
    var direction = window.getComputedStyle(list).flexDirection;
    if (direction !== "column" && direction !== "column-reverse") return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // Clear Dawn disabled so this and future clicks work
    button.removeAttribute("disabled");

    if (button.getAttribute("aria-disabled") === "true") return;

    var maxScroll = list.scrollHeight - list.clientHeight;
    if (maxScroll <= 1) {
      updateButtons(thumbs, list);
      return;
    }

    var step = getStep(list);
    if (button.name === "next") {
      if (list.scrollTop >= maxScroll - 1) {
        updateButtons(thumbs, list);
        return;
      }
      list.scrollBy({ top: step, behavior: "smooth" });
    } else {
      if (list.scrollTop <= 1) {
        updateButtons(thumbs, list);
        return;
      }
      list.scrollBy({ top: -step, behavior: "smooth" });
    }

    requestAnimationFrame(function () {
      updateButtons(thumbs, list);
    });
    setTimeout(function () {
      updateButtons(thumbs, list);
    }, 350);
  }

  function bindGallery(gallery) {
    if (gallery.dataset.kgThumbSliderBound === "true") return;
    gallery.dataset.kgThumbSliderBound = "true";

    var thumbs = getThumbnails(gallery);
    if (!thumbs) return;

    var list = getList(thumbs);
    var prev = thumbs.querySelector('button[name="previous"]');
    var next = thumbs.querySelector('button[name="next"]');

    // Capture phase so we run before Dawn SliderComponent
    if (prev) prev.addEventListener("click", onThumbButtonClick, true);
    if (next) next.addEventListener("click", onThumbButtonClick, true);

    // Dawn keeps re-applying [disabled]; strip it so clicks still fire
    if (typeof MutationObserver !== "undefined" && list) {
      var mo = new MutationObserver(function () {
        updateButtons(thumbs, list);
      });
      if (prev) mo.observe(prev, { attributes: true, attributeFilter: ["disabled"] });
      if (next) mo.observe(next, { attributes: true, attributeFilter: ["disabled"] });
    }

    if (list) {
      list.addEventListener("scroll", function () {
        updateButtons(thumbs, list);
      });
    }

    var sync = function () {
      requestAnimationFrame(function () {
        syncHeight(gallery);
      });
    };

    sync();
    setTimeout(sync, 100);
    setTimeout(sync, 400);
    setTimeout(sync, 1000);

    var viewer = getViewer(gallery);
    if (viewer && typeof ResizeObserver !== "undefined") {
      new ResizeObserver(sync).observe(viewer);
    }
    if (list && typeof ResizeObserver !== "undefined") {
      new ResizeObserver(sync).observe(list);
    }

    window.addEventListener("resize", sync);

    var imgs = gallery.querySelectorAll('[id^="GalleryViewer"] img');
    Array.prototype.forEach.call(imgs, function (img) {
      if (!img.complete) img.addEventListener("load", sync);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var galleries = scope.querySelectorAll
      ? scope.querySelectorAll(".kg-product media-gallery, .kg-main-product-section media-gallery")
      : [];
    Array.prototype.forEach.call(galleries, bindGallery);
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
